import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import LoadingSpinner from './LoadingSpinner';
import PricingPage from '../pages/PricingPage';
import DarkModeToggle from './DarkModeToggle';

const AuthWrapper = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'register'
  const [showPricing, setShowPricing] = useState(false);

  console.log('AuthWrapper - isAuthenticated:', isAuthenticated, 'loading:', loading, 'user:', user);

  if (loading) {
    return (
      <div className="auth-loading">
        <LoadingSpinner size="large" text="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="auth-container">
        <DarkModeToggle />
        <div className="auth-header">
          <h1>BioDawn Omics Analysis Platform</h1>
          <p>Sign in to access your account or create a new account to get started.</p>
        </div>

        <div className="auth-content">
          {showPricing ? (
            <div>
              <div style={{ marginBottom: 12 }}>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => setShowPricing(false)}
                >
                  ← Back to Sign In / Register
                </button>
              </div>
              <PricingPage />
            </div>
          ) : (
            authMode === 'login' ? (
              <LoginForm
                onSuccess={() => {
                  // Auth context will handle the redirect
                }}
                onSwitchToRegister={() => setAuthMode('register')}
              />
            ) : (
              <RegisterForm
                onSuccess={() => {
                  // Auth context will handle the redirect
                }}
                onSwitchToLogin={() => setAuthMode('login')}
              />
            )
          )}
        </div>

        <div className="auth-footer">
          {!showPricing && (
            <p style={{ marginBottom: 8 }}>
              <button
                type="button"
                className="link-button-home"
                onClick={() => setShowPricing(true)}
              >
                View Plans & Pricing
              </button>
            </p>
          )}
          <p>
            By signing in or creating an account, you agree to our{' '}
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthWrapper;
